const awsConfig = {
  Amplify: {
    Auth: {
      // REQUIRED - Amazon Cognito Identity Pool ID
      identityPoolId: "eu-west-1:a6b28f18-dab7-4334-9ca0-803bd731946f",
      // REQUIRED - Amazon Cognito Region
      region: "eu-west-1", 
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: "eu-west-1_qmq0y2zzV",
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: "4drb0gj1bi231e11jgltjr32ng",            //Identity_pools/{cognitoidentitypool}/User_access/Identity_provider
    },
    Storage: {
      AWSS3: {
        bucket: `ecs-gtwe-s3-backend-${process.env.REACT_APP_ENVIRONMENT}`, //REQUIRED -  Amazon S3 bucket name
        region: 'eu-west-1', //OPTIONAL -  Amazon service region
      }
    }
  },
  IoTCore: {
    aws_pubsub_region: 'eu-west-1',
    aws_pubsub_endpoint: 'wss://a2rpa6hk3zmo7d-ats.iot.eu-west-1.amazonaws.com/mqtt',

    //AWS-CLI for IoT Endpoint: aws iot describe-endpoint --endpoint-type iot:Data-ATS
  }
};

export default awsConfig;